import { baseUrl } from "./api";

export async function getPrivacyPolicy() {
  const origin = new URL(baseUrl).origin;
  const res = await fetch(`${origin}/uploads/cmspages/privacypolicy.html`);
  return res.text();
}
